import { Macro } from '../../../../firebase'

// マクロはユーザーが自由に入力できるため、HTMLとして解釈されないようにエスケープする
// エスケープした文字はブラウザ上で元の文字に戻ってからMathJaxに渡るので、TeXの内容は変わらない
const escapeMacroText = (text: string) =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// \newcommandの引数の数は0〜9の整数のみ有効なので、それ以外は0にする
const toArgumentsCount = (value: unknown) => {
  const count = Number(value)
  return Number.isInteger(count) && count >= 0 && count <= 9 ? count : 0
}

export const compileMacrosToHTML = (macros: Macro[], id?: string) => {
  let str = `<div class="d-none" ${
    id !== undefined ? `id="macros-${id}"` : ''
  }>$$`
  for (const macro of macros) {
    const commandName = escapeMacroText(String(macro.command_name))
    const argumentsCount = toArgumentsCount(macro.arguments_count)
    const formula = escapeMacroText(String(macro.formula))
    str += `\\newcommand{${commandName}}[${argumentsCount}]{${formula}}\n`
  }
  str += '$$</div>\n'
  return str
}

export const compileMacrosToTex = (macros: Macro[]) => {
  let str = ''
  for (const macro of macros) {
    str += `\\def\\${macro.command_name}`
    for (let i = 0; i < macro.arguments_count; i++) {
      str += `#${i + 1}`
    }
    str += `{${macro.formula}}\n`
  }
  return str
}
